<template>
    <el-dialog :title="title" :visible="dialogFormVisible" width="30%" :before-close="handleClose" :closeOnClickModal="false">
        <el-form label-width="120px" ref="model" :model="model" :rules="rules">
            <el-form-item label="单位名称" prop="SearchKey">
                <el-select v-model="companyModel.SearchKey" @change="handleSearchCompany" filterable remote reserve-keyword placeholder="请输入单位查询" :remote-method="remoteMethod2" :disabled="isdisabled">
                    <el-option v-for="item in companyList" :key="item.Code" :label="item.Name" :value="item.Code">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="AppKey" prop="AppKey">
                <el-input size="small" v-model="model.AppKey" auto-complete="off" placeholder="请输入AppKey" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="AppSecret" prop="AppSecret">
                <el-input size="small" v-model="model.AppSecret" auto-complete="off" placeholder="请输入AppSecret" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="AgentId" prop="AgentId">
                <el-input size="small" v-model="model.AgentId" auto-complete="off" placeholder="请输入AgentId" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="CorpId" prop="CorpId">
                <el-input size="small" v-model="model.CorpId" auto-complete="off" placeholder="请输入CorpId" maxlength="100"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='handleClose'>取消</el-button>
            <el-button size="small" type="primary" :loading="loading" class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {
        UpdateDingtalkInfo
    } from '../../api/dingding'
    import { GetCompanyList } from '../../api/company'
    export default {
        data() {
            return {
                title: '编辑钉钉',
                loading: false,
                companyList: [],
                isdisabled: false,
                model: {
                    Code: '',
                    AppKey: '',
                    AppSecret: '',
                    AgentId: '',
                    CorpId: ''
                },
                companyModel: {
                    Page: 1,
                    Rows: 10,
                    SearchKey: '',
                },
                rules: {
                    Code: [{ required: true, message: '请输入单位名称', trigger: 'blur' }],
                    AppKey: [{ required: true, message: '请输入AppKey', trigger: 'blur' }],
                    AppSecret: [{ required: true, message: '请输入AppSecret', trigger: 'blur' }],
                    AgentId: [{ required: true, message: '请输入AgentId', trigger: 'blur' }],
                    CorpId: [{ required: true, message: '请输入CorpId', trigger: 'blur' }],
                },
            }
        },
        props: {
            dialogFormVisible: {
                required: true,
                type: Boolean
            },
            data: {
                required: true,
                type: Object
            }
        },
        mounted() {
            this.model = this.data;
            this.companyModel.SearchKey = this.model.Code;
            console.log(this.model)
        },
        methods: {
            GetCompanyList() {
                GetCompanyList(this.companyModel).then(data => {
                    if (!data.iserror) {
                        this.companyList = data.data.List;
                        console.log(this.companyList)
                    }
                })
            },
            handleSearchCompany(val) {
                this.model.Code = val;
            },
            remoteMethod2(query) {
                console.log('query:'+query)
                this.companyModel.SearchKey = query;
                this.GetCompanyList();
            },
            handleSave() {
                this.$refs.model.validate((valid) => {
                    if (valid) {
                        this.UpdateDingtalkInfo()
                    } else {
                        this.$message({
                            message: '请填写完整信息',
                            type: 'error'
                        });
                    }
                });
            },
            handleClose() {
                this.$emit('closeEditDialog')
            },
            UpdateDingtalkInfo() {
                UpdateDingtalkInfo(this.model).then(data => {
                    if (!data.iserror) {
                        this.loading = false;
                        this.$message({
                            message: '更新成功',
                            type: 'success'
                        });
                        this.handleClose();
                    }
                })
            },
        }
    }
</script>

<style>

</style>